import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../language.service';

@Component({
  selector: 'app-language',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  template: `
    <div class="language-selector">
      <h3>{{ 'SELECT_LANGUAGE' | translate }}</h3>
      <div *ngFor="let lang of languages">
        <label>
          <input
            type="radio"
            name="language"
            [value]="lang.code"
            (change)="switchLanguage(lang.code)"
            [checked]="lang.code === selectedLanguage"
          />
          {{ lang.label }}
        </label>
      </div>
    </div>
  `,
  styleUrls: ['./language.component.css'],
})
export class LanguageComponent {
  languages = this.languageService.getLanguages();
  selectedLanguage = this.languageService.getCurrentLanguage();

  constructor(private languageService: LanguageService) {}

  switchLanguage(language: string): void {
    this.selectedLanguage = language;
    this.languageService.setLanguage(language);
  }
}
